var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cx_develop"},[_vm._v("[締処理] is under construction.. Please wait.")])}
var staticRenderFns = []

export { render, staticRenderFns }